import type { PlatformStrings } from './platformStrings';

// Swedish (Finland) — needs native-speaker review before go-live.
const n = (count: number, one: string, many: string) => (count === 1 ? one : many);

export const platformSv: PlatformStrings = {
  'err.generic': (detail: string) => `Något gick fel: ${detail}`,
  'err.not_authorized': 'Du har inte behörighet till detta i din nuvarande roll.',
  'err.unknown': 'Något gick fel. Försök igen; om det fortsätter, kontrollera plattformsloggen.',
  'err.ops_unreachable': 'Kontotjänsten gick inte att nå. Kontrollera anslutningen och försök igen.',
  'err.bad_request': 'Uppgifter saknas. Fyll i alla fält och försök igen.',
  'err.ack_missing': 'Registrera först rektorns bekräftelse.',
  'err.ack_required': 'Registrera vem som bekräftade och vilket datum (inte i framtiden).',
  'err.admins_without_mfa': 'Varje plattformsadministratör måste ta i bruk en autentiseringsapp innan tvåstegsverifiering kan krävas.',
  'err.already_invited': 'Den här e-postadressen har redan en väntande inbjudan.',
  'err.already_on_staff': 'Den här e-postadressen finns redan i personalen.',
  'err.already_requested': 'En begäran om radering för den här personen väntar redan på godkännande.',
  'err.bad_assignment': 'En av klasserna eller årskurserna hör inte till skolan. Ladda om och försök igen.',
  'err.bad_email': 'Ange en giltig e-postadress.',
  'err.bad_expiry': 'Välj en giltighet på 1–90 dagar.',
  'err.bad_language': 'Välj ett språk.',
  'err.bad_paperwork': 'Välj avtalets status.',
  'err.bad_role': 'Välj en roll i listan.',
  'err.bad_section': 'Parallellklassens namn är 1–8 tecken.',
  'err.bad_size': 'Elevantalet är ett tal från 1 till 200.',
  'err.bad_stage': 'Årskursen finns inte i skolans lista. Lägg till den under Klasser → Namngivning.',
  'err.bad_step': 'Okänt steg i checklistan.',
  'err.bad_test_login': 'Inloggningen kunde inte kopplas till ett testkonto. Försök igen.',
  'err.bad_type': 'Välj Sandlåda eller Kund.',
  'err.cannot_suspend': 'Bara en skola som håller på att tas i bruk eller är i bruk kan stängas av.',
  'err.cells_required': 'Kryssa för minst en klass i rutnätet.',
  'err.class_exists': 'Klassen finns redan.',
  'err.class_has_sessions': 'Klassen har enkäthistorik och kan bara arkiveras.',
  'err.confirm_mismatch': 'Det du skrev stämmer inte. Skriv det exakt för att bekräfta.',
  'err.confirmation_required': 'Registrera med vem på skolan du bekräftade detta.',
  'err.date_in_future': 'Datumet kan inte vara i framtiden.',
  'err.date_in_past': 'Datumet för återaktivering måste vara i framtiden.',
  'err.deactivate_first': 'Inaktivera personen innan uppgifterna raderas.',
  'err.duplicate_role': 'En roll finns två gånger i listan.',
  'err.duplicate_section': 'En parallellklass finns två gånger i listan.',
  'err.hold_not_over': 'Väntetiden på 30 dagar är inte över ännu.',
  'err.instruction_required': 'Registrera skolans skriftliga instruktion (vem som skickade den och när) i anteckningen.',
  'err.invites_customer_only': 'Sandlådeskolor använder testkonton, inte inbjudningar.',
  'err.last_school_admin': 'Det här är skolans sista skoladministratör. Lägg först till en till.',
  'err.mfa_session_needed': 'Logga först in med din autentiseringskod och försök sedan igen.',
  'err.name_required': 'Ange ett namn.',
  'err.no_active_year': 'Skolan har inget aktivt läsår.',
  'err.no_session': 'Din inloggning saknar sessions-id. Logga ut och in igen.',
  'err.not_a_head': 'Bara en aktiv biträdande rektor kan bli primär rektor.',
  'err.not_a_teacher': 'Ge först personen rollen Lärare.',
  'err.not_admin_role': 'Tvåstegsverifiering nollställs bara för personer med en administratörsroll.',
  'err.not_in_school': 'Personen hör inte till skolans personal.',
  'err.not_platform_admin': 'Personen är inte plattformsadministratör.',
  'err.not_sandbox': 'Bara en sandlådeskola kan bli kundskola.',
  'err.not_suspended': 'Skolan är inte avstängd.',
  'err.not_test_account': 'Bara testkontons lösenord kan nollställas. Riktig personal har inget lösenord i Swipe.',
  'err.not_yourself': 'En annan plattformsadministratör måste nollställa din egen tvåstegsverifiering.',
  'err.note_required': 'Berätta kort varför.',
  'err.own_request': 'Du kan inte avgöra en begäran du själv gjort eller en som gäller dig själv.',
  'err.paperwork_signed_needs': 'Ett undertecknat avtal behöver datum och undertecknarens namn.',
  'err.person_not_active': 'Personen är inte aktiv. Återaktivera först.',
  'err.person_not_deactivated': 'Personen är inte inaktiverad.',
  'err.primary_head': 'Det här är den primära rektorn. Flytta först primärmarkeringen till en biträdande rektor.',
  'err.primary_head_decides': 'Skolan har en primär rektor som avgör den här begäran.',
  'err.reason_required': 'Välj en orsak (och fyll i nödvändiga uppgifter).',
  'err.request_expired': 'Begäran har gått ut.',
  'err.request_gone': 'Begäran är redan avgjord eller återtagen.',
  'err.role_exists': 'Personen har redan den här rollen eller en begäran om den.',
  'err.role_required': 'Välj minst en roll.',
  'err.school_name_taken': 'Det finns redan en skola med det här namnet.',
  'err.school_not_active': 'Skolan är avstängd eller har lämnat Swipe.',
  'err.school_not_ready': 'Enkäterna öppnas när skolans ibruktagning är klar.',
  'err.school_offboarded': 'Skolan har lämnat Swipe.',
  'err.second_admin_needed': 'En annan plattformsadministratör måste avgöra begäran.',
  'err.sections_required': 'Behåll minst en parallellklass.',
  'err.stage_in_use': 'En årskurs med klasser kan inte tas bort. Arkivera klasserna först.',
  'err.support_required': 'Gå först till supportläge för skolan.',
  'err.test_accounts_remain': 'Radera först skolans testkonton.',
  'err.test_accounts_sandbox_only': 'Testkonton finns bara i sandlådeskolor.',
  'err.test_expired': 'Testkontot har gått ut. Förläng det först.',
  'err.tier_required': 'En kundskola behöver en nivå.',
  'err.too_long': 'Håll varje meddelande under 600 tecken.',
  'err.two_admins_needed': 'Zencera behöver minst två plattformsadministratörer innan tvåstegsverifiering krävs.',
  'err.unknown_assignment': 'Uppdraget har redan avslutats.',
  'err.unknown_class': 'Okänd klass. Ladda om och försök igen.',
  'err.unknown_invite': 'Inbjudan är redan använd eller återkallad.',
  'err.unknown_municipality': 'Välj en kommun.',
  'err.unknown_person': 'Personens uppgifter är redan raderade.',
  'err.unknown_role': 'Rollen är redan borttagen.',
  'err.unknown_school': 'Okänd skola.',

  'pa.navApprovals': 'Godkännanden',
  'pa.navApprovalsN': (c: number) => `Godkännanden (${c})`,
  'pa.navLog': 'Plattformslogg',
  'pa.navArchive': 'Arkiv',
  'pa.navSettings': 'Inställningar',
  'pa.working': 'Behandlas…',
  'pa.save': 'Spara',
  'pa.saved': 'Sparat.',
  'pa.close': 'Stäng',
  'pa.keep': 'Behåll',
  'pa.back': '← Tillbaka',
  'pa.next': 'Nästa',
  'pa.add': 'Lägg till',
  'pa.edit': 'Redigera',
  'pa.remove': 'Ta bort',
  'pa.withdraw': 'Återta begäran',
  'pa.view': 'Visa',
  'pa.hide': 'Dölj',
  'pa.download': 'Ladda ner',
  'pa.copy': 'Kopiera',
  'pa.copied': 'Kopierat',
  'pa.copyFailed': 'Kopieringen misslyckades. Markera texten och kopiera den själv.',
  'pa.copyCode': 'Kopiera skolkoden',
  'pa.copyUsername': 'Kopiera användarnamnet',
  'pa.copyPassword': 'Kopiera lösenordet',
  'pa.optional': 'Valfritt.',
  'pa.note': 'Anteckning',
  'pa.noteOptional': 'Anteckning (valfri)',
  'pa.reason': 'Orsak',
  'pa.status': 'Status',
  'pa.done': 'Klar',
  'pa.notDone': 'Inte klar',
  'pa.yes': 'Ja',
  'pa.missing': 'Saknas',
  'pa.never': 'aldrig',
  'pa.nothing': 'ingenting',
  'pa.you': 'du',
  'pa.on': 'På',
  'pa.off': 'Av',
  'pa.actions': 'Åtgärder',
  'pa.loadMore': 'Ladda fler',
  'pa.name': 'Namn',
  'pa.email': 'E-post',
  'pa.language': 'Språk',
  'pa.schoolDefault': 'Skolans standard',
  'pa.lang_fi': 'finska',
  'pa.lang_sv': 'svenska',
  'pa.lang_en': 'engelska',
  'pa.tier_a': 'Nivå A',
  'pa.tier_b': 'Nivå B',
  'pa.tier_aDesc': 'Delad databas. Skolans uppgifter finns i Swipes gemensamma databas och hålls åtskilda från andra skolor med behörighetsregler. Standardpris.',
  'pa.tier_bDesc': 'Egen databas. Skolan får en egen databas, helt skild från alla andra skolor, som ändå hanteras från den här plattformen. Tilläggspris.',
  'pa.tierHint': 'Nivå B ber Zencera att sätta upp en egen databas. Skolan stannar i ibruktagning tills Zencera bekräftar att databasen är klar.',
  'pa.comingLater': 'Kommer senare',
  'pa.tier_bSoon': 'Inte tillgänglig ännu. Nivå B öppnas när Zencera kan sätta upp och driva egna databaser från den här plattformen.',
  'err.tier_b_unavailable': 'Nivå B (egen databas) är inte tillgänglig ännu. Välj nivå A.',
  'pa.tier_aShort': 'Nivå A · delad databas',
  'pa.tier_bShort': 'Nivå B · egen databas',
  'pa.school': 'Skola',
  'pa.person': 'Person',

  'pa.statLive': 'Skolor i bruk',
  'pa.statLiveSub': (setting: number, suspended: number) => `${setting} tas i bruk · ${suspended} avstängda`,
  'pa.statApprovals': 'Väntande godkännanden',
  'pa.statApprovalsSub': 'för Zencera att avgöra',
  'pa.statTests': 'Testkonton',
  'pa.statTestsSub': (expiring: number) => `${expiring} går ut inom 7 dagar`,
  'pa.addSchoolDesc': 'Sandlåda eller kund, med de första personerna.',
  'pa.approvalsDesc': 'Begäranden som bara Zencera kan avgöra.',
  'pa.logDesc': 'Alla åtgärder mellan skolor, logg som bara kan utökas.',
  'pa.attnSetup': (s: string, d: number, total: number) => `${s}: ${d} av ${total} obligatoriska punkter klara.`,
  'pa.attnSeeChecklist': 'Se checklistan',
  'pa.attnOffboardReady': (s: string) => `${s}: väntetiden på 30 dagar är över; klar att avvecklas.`,
  'pa.attnOffboardAck': (s: string) => `${s}: väntetiden är över, men rektorns bekräftelse är inte registrerad.`,
  'pa.attnNoSchoolAdmin': (s: string) => `${s}: ingen aktiv skoladministratör.`,
  'pa.attnOneAdmin': 'Zencera har bara en plattformsadministratör. Lägg till en till (README §6).',
  'pa.attnApprovals': (c: number) => `${c} ${n(c, 'begäran väntar', 'begäranden väntar')} på Zencera.`,
  'pa.attnReview': 'Granska',
  'pa.attnTestsExpired': (c: number) => `${c} ${n(c, 'utgånget testkonto väntar', 'utgångna testkonton väntar')} på radering.`,

  'pa.searchSchools': 'Sök på namn eller kod',
  'pa.filterType': 'Filtrera efter typ',
  'pa.filterState': 'Filtrera efter läge',
  'pa.allTypes': 'Alla typer',
  'pa.allStates': 'Alla lägen',
  'pa.stateNotOffboarded': 'Alla utom avvecklade',
  'pa.noMatch': 'Inga skolor matchar filtren.',
  'pa.municipality': 'Kommun',
  'pa.staff': 'Personal',
  'pa.nTest': (c: number) => `${c} test`,
  'pa.lastActivity': 'Senaste aktivitet',
  'pa.setupProgress': (d: number, total: number) => `Ibruktagning: ${d} av ${total} obligatoriska`,
  'pa.agreementShort': 'Avtal',
  'pa.dpaShort': 'Biträdesavtal',
  'pa.paperworkPill': (doc: string, status: string) => `${doc}: ${status}`,
  'pa.pwNotStarted': 'Inte påbörjat',
  'pa.pwSent': 'Skickat',
  'pa.pwSigned': 'Undertecknat',

  'pa.wizSteps': 'Steg',
  'pa.wizStepOf': (i: number, total: number, name: string) => `Steg ${i} av ${total}: ${name}`,
  'pa.wizType': 'Typ',
  'pa.wizDetails': 'Uppgifter',
  'pa.wizPaperwork': 'Avtal',
  'pa.wizPeople': 'Första personerna',
  'pa.wizReview': 'Granskning',
  'pa.schoolType': 'Skolans typ',
  'pa.sandboxDesc': 'Pilotskola. Skolan är personuppgiftsansvarig och undertecknar ett sandlådeavtal. Personalen använder testkonton som Zencera skapar; ingen e-post skickas.',
  'pa.customerDesc': 'Betalande skola med fullständigt personuppgiftsbiträdesavtal. Personalen ansluter via e-postinbjudan och loggar in med en engångskod.',
  'pa.typeHint': 'En sandlådeskola kan senare bli kundskola, aldrig tvärtom.',
  'pa.chooseMunicipality': 'Välj kommun…',
  'pa.codeFromMunicipality': 'Skolkoden bildas av den (FI-HEL-7KQ2) och ändras aldrig.',
  'pa.officialNumber': 'Läroanstaltsnummer',
  'pa.stages': 'Årskurser',
  'pa.stagesHint': 'De blir raderna i klassrutnätet. Du kan ändra dem senare.',
  'pa.levelsBasic': 'Grundläggande utbildning',
  'pa.levelsUpper': 'Gymnasium',
  'pa.levelsVocational': 'Yrkesutbildning',
  'pa.defaultLanguage': 'Standardspråk',
  'pa.tier': 'Nivå',
  'pa.wizStagesNeeded': 'Välj minst en årskurs.',
  'pa.agreement': 'Sandlådeavtal',
  'pa.dpa': 'Personuppgiftsbiträdesavtal',
  'pa.paperworkSandboxHint': 'Bara Zencera anger detta. Skolan ser det på sin checklista; enkäterna öppnas när avtalet är undertecknat.',
  'pa.paperworkCustomerHint': 'Bara Zencera anger detta. Enkäterna öppnas när avtalet är undertecknat och ibruktagningen klar.',
  'pa.signedOn': 'Undertecknat den',
  'pa.signatory': 'Undertecknat av (skolans undertecknare)',
  'pa.signedBy': (who: string, date: string) => `Undertecknat av ${who}, ${date}`,
  'pa.peopleSandboxNote': 'Testkonton skapas nu för de här rollerna; användarnamn och lösenord visas en gång. Använd påhittade namn — skolan håller själv en lista över vem som har vilket konto.',
  'pa.peopleCustomerNote': 'Inbjudningarna köas nu och skickas när en e-posttjänst finns. Var och en loggar in med en engångskod; inget lösenord skapas.',
  'pa.headName': 'Rektor (primär)',
  'pa.headNameTest': 'Rektor (primär) — påhittat namn',
  'pa.fictionalExample': 't.ex. Helmi Koivu (TEST)',
  'pa.workEmail': 'Arbetsmejl',
  'pa.sameAdmin': 'Rektorn är också skoladministratör',
  'pa.adminName': 'Skoladministratör',
  'pa.adminNameTest': 'Skoladministratör — påhittat namn',
  'pa.wizHeadNeeded': 'Ange rektorns namn.',
  'pa.wizAdminNeeded': 'Ange skoladministratörens namn.',
  'pa.firstPeople': 'Första personerna',
  'pa.reviewSame': (h: string) => `${h} — primär rektor och skoladministratör`,
  'pa.reviewTwo': (h: string, a: string) => `${h} — primär rektor; ${a} — skoladministratör`,
  'pa.afterCreate': 'När du skapar skolan',
  'pa.afterCreateSandbox': 'Du går till skolans supportläge (loggas) och testkontona skapas.',
  'pa.afterCreateCustomer': 'Du går till skolans supportläge (loggas) och inbjudningarna köas.',
  'pa.createSchool': 'Skapa skola',
  'pa.codeHint': 'Personalen skriver koden på inloggningssidan. Dela den med skolan.',
  'pa.credsTitle': 'Testkontots inloggningsuppgifter',
  'pa.credsOnce': 'Visas bara nu. Ge lösenordet via en annan kanal än användarnamnet — personligen, per telefon eller i ett annat meddelande — aldrig tillsammans. Det fungerar bara en gång: vid första inloggningen måste personen välja ett eget lösenord innan något öppnas.',
  'pa.username': 'Användarnamn',
  'pa.password': 'Lösenord',
  'pa.invitesQueuedNote': 'Inbjudningarna står i kö: ingen e-posttjänst finns ännu, så inget skickas. De går ut automatiskt när den finns.',
  'pa.peopleFailed': 'Skolan skapades, men de här personerna lades inte till. Lägg till dem på skolans flik Personal:',
  'pa.openSchool': 'Öppna skolan',

  'pa.schoolSummary': 'Sammanfattning av skolan',
  'pa.schoolSections': 'Skolans delar',
  'pa.inSupportPill': 'Supportläge på',
  'pa.inSupportHint': 'Du är i supportläge för den här skolan. Allt du gör loggas och syns för skolan.',
  'pa.enterSupport': 'Gå till supportläge',
  'pa.enterSupportGo': 'Gå till supportläge',
  'pa.enterSupportIntro': 'I supportläget kan du ändra skolans personal, klasser och inställningar i två timmar. En banderoll syns i varje vy, varje åtgärd syns i skolans egen aktivitetslogg och resultaten förblir dolda.',
  'pa.supportEntered': (s: string) => `Supportläge på för ${s}.`,
  'pa.supportLeft': 'Supportläget avslutades.',
  'pa.supportRegion': 'Supportläge',
  'pa.supportBanner': 'Supportläge — Zencera. Åtgärderna loggas och syns för skolan.',
  'pa.supportEnds': (m: number) => `slutar om ${m} min`,
  'pa.supportLeave': 'Lämna supportläget',
  'pa.supportNeeded': (what: string) => `För att ${what}, gå till skolans supportläge.`,
  'pa.sr_school_asked': 'Skolan bad om hjälp',
  'pa.sr_setup_stuck': 'Ibruktagningen har fastnat',
  'pa.sr_account_recovery': 'Återställning av konto',
  'pa.sr_approval_no_primary_head': 'Godkännande utan primär rektor',
  'pa.sr_test_accounts': 'Testkonton',
  'pa.sr_other': 'Annat',
  'pa.tabStaff': (c: number) => `Personal (${c})`,
  'pa.tabStaffPlain': 'Personal',
  'pa.tabClasses': (c: number) => `Klasser (${c})`,
  'pa.tabSettings': 'Inställningar',
  'pa.tabActivity': 'Aktivitet',
  'pa.checklist': 'Checklista för ibruktagning',
  'pa.gateSandbox': 'Sandlåda: bara stödmeddelandet och det undertecknade avtalet blockerar enkäterna, eftersom riktiga elever ser enkätvyn. Resten är varningar.',
  'pa.gateCustomer': 'Kund: varje obligatorisk punkt måste vara klar innan enkäterna öppnas.',
  'pa.gateDone': 'Ibruktagningen är tillräckligt klar för enkäter. Varningar syns fortfarande för personalen.',
  'pa.requiredTodo': 'Obligatorisk',
  'pa.warningTodo': 'Varning',
  'pa.ckSafetyNet': 'Stödmeddelande (finska, svenska, engelska)',
  'pa.ckPaperworkSandbox': 'Sandlådeavtalet undertecknat',
  'pa.ckPaperworkCustomer': 'Biträdesavtalet undertecknat',
  'pa.ckProfile': 'Skolans uppgifter, årskurser och parallellklasser bekräftade',
  'pa.ckClasses': 'Klasser skapade',
  'pa.ckStaffSandbox': 'Testkonton skapade',
  'pa.ckStaffCustomer': 'Personal inbjuden',
  'pa.ckTeachers': 'Varje lärare kopplad till en klass',
  'pa.ckNotice': 'Meddelande till vårdnadshavare och elever skickat',
  'pa.ckDpo': 'Dataskyddsombudets godkännande',
  'pa.ckDedicated': 'Egen databas bekräftad av Zencera (nivå B)',
  'pa.confirmDedicated': 'Bekräfta klar',
  'pa.dedicatedTitle': 'Bekräfta den egna databasen',
  'pa.dedicatedIntro': 'Bekräfta först när skolans egen databas är uppsatt och kontrollerad. Det loggas i skolans aktivitet, och skolans administratörer och primära rektor meddelas. Skolan tas i bruk när dess övriga obligatoriska steg är klara.',
  'pa.dedicatedRefLabel': 'Den egna databasens referens',
  'pa.dedicatedRefHint': 'Till exempel Supabase-projektets referens. Visas i skolans logg; aldrig ett lösenord eller en nyckel.',
  'pa.dedicatedRef': (ref: string) => `Klar · ${ref}`,
  'pa.dedicatedConfirmed': 'Egen databas bekräftad.',
  'err.not_requested': 'Skolan har ingen egen databas som väntar på bekräftelse.',
  'err.reference_required': 'Skriv den egna databasens referens.',
  'err.reference_too_long': 'Referensen får vara högst 200 tecken.',
  'pa.changePaperwork': 'Ändra',
  'pa.goSettings': 'Inställningar',
  'pa.goClasses': 'Klasser',
  'pa.goStaff': 'Personal',
  'pa.markDone': 'Markera som klar',
  'pa.reopen': 'Öppna igen',
  'pa.markDoneIntro': 'Markera steget som klart för skolan. Det loggas med ditt namn och tidpunkten.',
  'pa.reopenIntro': 'Öppna steget igen. Om det är obligatoriskt förblir enkäterna öppna tills du stänger av skolan.',
  'pa.paperworkOnlyZencera': 'Bara Zencera anger avtalets status. Den kopieras till arkivet för kritiska handlingar.',
  'pa.nowLive': 'Sparat. Alla obligatoriska punkter är klara: skolan är nu i bruk.',
  'pa.about': 'Om skolan',
  'pa.contractRef': 'Avtalsreferens',
  'pa.created': 'Skapad',
  'pa.classes': 'Klasser',
  'pa.nNoTeacher': (c: number) => `${c} utan lärare`,
  'pa.primaryHead': 'Primär rektor',
  'pa.schoolAdmins': 'Skoladministratörer',
  'pa.supportHistory': 'Senaste supportlägen',

  'pa.lifecycle': 'Skolans livscykel',
  'pa.lifecycleHint': 'Åtgärder på plattformsnivå. De kräver inte supportläge och registreras i plattformsloggen och arkivet.',
  'pa.suspend': 'Stäng av skolan',
  'pa.suspendTitle': (s: string) => `Stänga av ${s}?`,
  'pa.suspendIntro': 'Personalen loggas ut och kan inte logga in. Öppna enkäter stängs; elevernas länkar visar att enkäterna är pausade, med stödmeddelandet. Inget raderas och du kan återuppta när som helst.',
  'pa.sus_contract_lapse': 'Avtalet har löpt ut',
  'pa.sus_data_protection': 'Dataskyddsfråga',
  'pa.sus_sandbox_ended': 'Sandlådan slut, beslut väntar',
  'pa.sus_other': 'Annat',
  'pa.suspendMessage': 'Meddelande till personalen (valfritt)',
  'pa.suspendMessageHint': 'Visas för skolans personal på inloggningssidan.',
  'pa.suspendedDone': 'Skolan avstängd.',
  'pa.suspendedSince': (d: string) => `Avstängd sedan ${d}`,
  'pa.resume': 'Återuppta skolan',
  'pa.resumeTitle': (s: string) => `Återuppta ${s}?`,
  'pa.resumeIntro': 'Personalen kan logga in igen och skolan återgår till sitt tidigare läge.',
  'pa.resumedDone': 'Skolan återupptagen.',
  'pa.convert': 'Ändra till kund',
  'pa.convertTitle': 'Ändra Sandlåda → Kund',
  'pa.convertIntro': 'Därefter gäller kundens checklista: nya obligatoriska punkter öppnar ibruktagningen igen och blockerar enkäterna tills de är klara. Ändringen kan inte ångras.',
  'pa.convertTestsFirst': (c: number) => `Radera först skolans ${c} ${n(c, 'testkonto', 'testkonton')} (fliken Personal).`,
  'pa.convertedDone': 'Skolan är nu en kundskola.',
  'pa.offStepHold': (d: string) => `Väntetiden på 30 dagar slutar ${d}. Under väntetiden kan skolan exportera sina uppgifter.`,
  'pa.offStepAck': 'Den primära rektorn bekräftar att anonyma sammanställningar behålls.',
  'pa.offStepAckDone': (who: string, d: string) => `Bekräftat av ${who}, ${d}.`,
  'pa.offStepConfirm': 'Skriv skolkoden för att avveckla skolan.',
  'pa.recordAck': 'Registrera bekräftelse',
  'pa.ackIntro': 'Registrera den primära rektorns skriftliga bekräftelse av den här texten:',
  'pa.ackText': 'Anonyma sammanställningar över skyddsgränsen behålls av Zencera efter avvecklingen, enligt vårt avtal.',
  'pa.ackBy': 'Bekräftat av',
  'pa.ackOn': 'Bekräftat den',
  'pa.offboard': 'Avveckla skolan',
  'pa.offboardTitle': (s: string) => `Avveckla ${s}?`,
  'pa.offboardIntro': 'Detta kan inte ångras.',
  'pa.offboardErase': (c: number) => `Personuppgifterna för ${c} anställda och testkonton raderas.`,
  'pa.offboardKeep': 'Anonyma sammanställningar behålls, enligt bekräftelsen.',
  'pa.offboardReport': 'Undertecknarens GDPR-sammanfattning sparas i arkivet.',
  'pa.typeCode': (code: string) => `Skriv ${code} för att bekräfta`,
  'pa.offboardedDone': 'Skolan avvecklad. GDPR-sammanfattningen finns i arkivet.',
  'pa.offboardedOn': (d: string) => `Avvecklad ${d}. Personalens uppgifter raderades; anonyma sammanställningar behålls.`,
  'pa.seeReport': 'Visa GDPR-sammanfattningen',

  'pa.people': 'Personer',
  'pa.noPeople': 'Ingen har ännu en roll i skolan.',
  'pa.addTestAccount': '+ Lägg till testkonto',
  'pa.inviteStaff': '+ Bjud in personal',
  'pa.whatTestAccounts': 'lägga till eller ändra testkonton',
  'pa.whatInvite': 'bjuda in eller ändra personal',
  'pa.whatPerson': 'ändra personens roller, klasser eller konto',
  'pa.whatClasses': 'lägga till klasser eller koppla lärare',
  'pa.whatSettings': 'ändra skolans uppgifter, regler eller stödmeddelande',
  'pa.noClasses': 'Inga klasser',
  'pa.gradeLeadOf': (g: string) => `Ansvarig för årskurs ${g}`,
  'pa.expires': (d: string) => `Går ut ${d}`,
  'pa.lastSignIn': (d: string) => `Senaste inloggning: ${d}`,
  'pa.invites': 'Väntande inbjudningar',
  'pa.inviteQueued': 'I kö',
  'pa.inviteSent': 'Skickad',
  'pa.cancelInvite': 'Återkalla inbjudan',
  'pa.cancelInviteFor': (who: string) => `Återkalla inbjudan för ${who}`,
  'pa.cancelInviteIntro': 'Inbjudan kan inte användas efter detta. Du kan bjuda in personen igen senare.',
  'pa.inviteCancelled': 'Inbjudan återkallad.',
  'pa.testIntro': 'Ett testkonto för sandlådan: påhittat namn, genererat användarnamn (en adress som inte kan ta emot post) och lösenord, TEST-märkning överallt. Kontot raderas automatiskt när det går ut.',
  'pa.inviteIntro': 'Personen får en inbjudan per e-post (när en e-posttjänst finns) och loggar in med en engångskod.',
  'pa.fictionalName': 'Påhittat visningsnamn',
  'pa.fullName': 'Fullständigt namn',
  'pa.roles': 'Roller',
  'pa.role': 'Roll',
  'pa.makePrimary': 'Primär rektor (om skolan saknar en)',
  'pa.counsellorScope': 'Ser',
  'pa.wholeSchool': 'Hela skolan',
  'pa.chosenGrades': 'Valda årskurser',
  'pa.gradeN': (g: string) => `Årskurs ${g}`,
  'pa.noClassesYet': 'Inga klasser ännu — lägg till dem på fliken Klasser och koppla sedan.',
  'pa.classesOptional': 'Klasser (valfritt)',
  'pa.kindFor': (c: string) => `Typ av uppdrag i ${c}`,
  'pa.kind': 'Typ',
  'pa.kind_homeroom': 'Klasslärare',
  'pa.kind_subject': 'Ämneslärare',
  'pa.kind_grade_lead': 'Årskursansvarig',
  'pa.kindHint_homeroom': 'Öppnar enkäter och ser klassens resultat. Vanligen en per klass.',
  'pa.kindHint_subject': 'Öppnar enkäter och ser klassens resultat. Flera per klass.',
  'pa.kindHint_grade_lead': 'Ser årskursens resultat; öppnar enkäter bara i klasser som också är kopplade.',
  'pa.expiresIn': 'Giltig i',
  'pa.nDays': (d: number) => `${d} dagar`,
  'pa.inviteLanguage': 'Inbjudans språk',
  'pa.wideningNote': 'Rektor, kurator och skoladministratör utökar vad någon ser: de väntar på den primära rektorns godkännande (eller Zenceras, om skolan saknar primär rektor).',
  'pa.createTest': 'Skapa testkonto',
  'pa.queueInvite': 'Köa inbjudan',
  'pa.addAnother': 'Lägg till en till',
  'pa.testCreated': (who: string) => `Testkonto skapat för ${who}.`,
  'pa.inviteQueuedDone': (who: string) => `Inbjudan till ${who} i kö.`,
  'pa.schoolCodeForLogin': (code: string) => `På inloggningssidan anges först skolkoden ${code}.`,
  'pa.roleName_school_admin': 'Skoladministratör',
  'pa.roleName_head_of_school': 'Rektor',
  'pa.roleName_counsellor': 'Kurator',
  'pa.roleName_teacher': 'Lärare',
  'pa.rolePrimaryHead': 'Rektor (primär)',
  'pa.roleDeputyHead': 'Rektor (biträdande)',
  'pa.rolePending': (r: string) => `${r} — väntar på godkännande`,
  'pa.statusActive': 'Aktiv',
  'pa.statusActiveTest': 'Aktiv (TEST)',
  'pa.statusDeactivated': 'Inaktiverad',
  'pa.statusExpired': 'Utgången',

  'pa.personGone': 'Personen hör inte längre till skolans personal (uppgifterna kan ha raderats).',
  'pa.backToStaff': '← Tillbaka till personalen',
  'pa.details': 'Uppgifter',
  'pa.expiry': 'Går ut',
  'pa.lastSignInLabel': 'Senaste inloggning',
  'pa.authenticators': 'Autentiseringsappar',
  'pa.otherSchools': 'Andra skolor',
  'pa.otherSchoolsN': (c: number) => `Även personal vid ${c} ${n(c, 'annan skola', 'andra skolor')}`,
  'pa.reactivatesOn': (d: string) => `återaktiveras ${d}`,
  'pa.account': 'Inloggning och konto',
  'pa.signOutEverywhere': 'Logga ut överallt',
  'pa.signOutIntro': (who: string) => `${who} loggas ut på alla enheter inom en minut.`,
  'pa.resetPassword': 'Nollställ lösenordet',
  'pa.resetPasswordIntro': 'Ett nytt lösenord skapas och visas en gång. Det gamla slutar fungera och personen loggas ut. Inget öppnas med det nya förrän personen väljer ett eget lösenord.',
  'pa.passwordReset': 'Nytt lösenord skapat.',
  'pa.extendExpiry': 'Förläng giltigheten',
  'pa.extendIntro': 'Anger ett nytt utgångsdatum räknat från i dag (högst 90 dagar).',
  'pa.resetMfa': 'Nollställ tvåstegsverifieringen',
  'pa.resetMfaFor': (who: string) => `Nollställ tvåstegsverifieringen för ${who}`,
  'pa.resetMfaIntro': 'Tar bort personens autentiseringsappar så att hen kan ta i bruk en ny. Bekräfta först identiteten utanför appen (samtal till ett känt nummer eller personligen).',
  'pa.resetMfaAdminIntro': 'Tar bort plattformsadministratörens autentiseringsappar. Bekräfta först identiteten utanför appen.',
  'pa.confirmedHow': 'Hur du bekräftade identiteten',
  'pa.deactivate': 'Inaktivera',
  'pa.deactivateTitle': (who: string) => `Inaktivera ${who}?`,
  'pa.deactivateIntro': (who: string, c: number) =>
    `${who} loggas ut och kan inte logga in. ${c} ${n(c, 'klassuppdrag tas', 'klassuppdrag tas')} bort. Resultaten från hens enkäter finns kvar i klassens och skolans historik.`,
  'pa.deactivateOther': 'Personen arbetar också vid en annan skola, så bara rollerna här upphör; kontot förblir aktivt där.',
  'pa.dr_left_school': 'Lämnade skolan',
  'pa.dr_leave': 'Ledig',
  'pa.dr_role_ended': 'Uppdraget upphörde',
  'pa.dr_other': 'Annat',
  'pa.reactivateOn': 'Återaktivera automatiskt den',
  'pa.deactivated': 'Inaktiverad.',
  'pa.soleTeacher': (classes: string) => `Inaktiverad. De här klasserna saknar nu lärare: ${classes}.`,
  'pa.reassignNow': 'Koppla en ny lärare nu',
  'pa.reactivate': 'Återaktivera',
  'pa.restoreAssignments': 'Återställ också de senaste klassuppdragen',
  'pa.erase': 'Radera personuppgifter',
  'pa.eraseTitle': (who: string) => `Radera personuppgifterna för ${who}?`,
  'pa.eraseIntro': 'Inloggning, namn och e-post raderas; loggarna visar ”Tidigare anställd #NNNN”. Enkätantal och sammanställningar påverkas inte. Ett kvitto sparas i arkivet. Detta kan inte ångras.',
  'pa.eraseSecondAdmin': 'Personen är skoladministratör eller primär rektor: en annan plattformsadministratör måste godkänna raderingen enligt skolans skriftliga instruktion.',
  'pa.eraseAfterDeactivate': 'Riktig personal inaktiveras först; därefter kan uppgifterna raderas.',
  'pa.er_own_request': 'Personens egen begäran',
  'pa.er_left_school': 'Lämnade skolan',
  'pa.er_test_cleanup': 'Städning av test',
  'pa.er_other': 'Annat',
  'pa.instruction': 'Skolans skriftliga instruktion (vem, när)',
  'pa.typeEmail': (e: string) => `Skriv ${e} för att bekräfta`,
  'pa.erasedDone': 'Personuppgifterna raderade. Kvittot finns i arkivet.',
  'pa.eraseRequested': 'Radering begärd. Den görs när en annan plattformsadministratör godkänner den under Godkännanden.',
  'pa.addRole': '+ Lägg till roll',
  'pa.before': 'Nu:',
  'pa.after': 'Efter:',
  'pa.reachHead': 'skolans, årskursernas och klassernas resultat',
  'pa.reachAdmin': 'personal, klasser och inställningar — inga resultat',
  'pa.reachCounsellorAll': 'alla årskursers resultat, hela skolan',
  'pa.reachCounsellorGrades': (g: string) => `resultat för årskurserna ${g}`,
  'pa.reachTeacher': (c: string) => `resultat för klasserna ${c}`,
  'pa.reachTeacherNone': 'inga klasser ännu',
  'pa.roleAddedNow': 'Rollen tillagd. Den gäller från personens nästa åtgärd.',
  'pa.roleToHead': 'Begäran skickad till den primära rektorn för godkännande.',
  'pa.roleToZencera': 'Skolan saknar primär rektor, så begäran finns under Zenceras Godkännanden. Bekräfta med skolans undertecknare innan du godkänner.',
  'pa.removeRoleTitle': (r: string) => `Ta bort rollen ${r}?`,
  'pa.removeRoleIntro': 'Personen förlorar genast det som rollen ser. Om rollen Lärare tas bort avslutas också klassuppdragen.',
  'pa.removeRoleFor': (r: string) => `Ta bort rollen ${r}`,
  'pa.makePrimaryAction': 'Gör till primär rektor',
  'pa.makePrimaryIntro': 'Flyttar primärmarkeringen från den nuvarande rektorn. Gör detta bara efter att ha bekräftat med skolans undertecknare; flytten sparas i arkivet.',
  'pa.confirmedWith': 'Bekräftat med (vem, hur, när)',
  'pa.confirmedWithHint': (s: string) => `Skolans registrerade undertecknare: ${s}.`,
  'pa.editDetails': 'Redigera uppgifter',
  'pa.emailChangeLater': 'Byte av e-post bekräftas från den nya adressen när inloggning via e-post är i bruk.',
  'pa.assignments': 'Klasser och årskurser',
  'pa.assign': 'Koppla',
  'pa.assignTitle': (who: string) => `Koppla ${who}`,
  'pa.grade': 'Årskurs',
  'pa.noClassesWho': 'Inga klasser ännu. Hens vy berättar vem hen ska fråga.',
  'pa.notATeacher': 'Bara personer med rollen Lärare kopplas till klasser.',
  'pa.unassign': 'Koppla bort',
  'pa.unassignFrom': (c: string) => `Koppla bort från ${c}?`,
  'pa.unassignIntro': 'Tillgången till klassens resultat upphör genast. En öppen enkät pågår till slutet och svaren räknas.',
  'pa.unassignedOpen': 'Bortkopplad. En enkät är öppen i klassen; den pågår till slutet.',
  'pa.secondHomeroom': (c: string) => `Kopplad. Obs: ${c} har nu två klasslärare.`,
  'pa.activity': 'Aktivitet',

  'pa.namingConvention': 'Namngivning',
  'pa.editLists': 'Redigera årskurser och parallellklasser',
  'pa.levelsNow': (l: string) => `Årskurser: ${l}`,
  'pa.sectionsNow': (s: string) => `Parallellklasser: ${s}`,
  'pa.listsIntro': 'Klassernas namn bildas av de här listorna (årskurs 7 + A = 7A), de skrivs aldrig för hand.',
  'pa.levelsInUseHint': 'En årskurs med klasser kan inte tas bort.',
  'pa.sectionScheme': 'Beteckning för parallellklasser',
  'pa.scheme_letters': 'Bokstäver A–F',
  'pa.scheme_numbers': 'Siffror 1–6',
  'pa.scheme_custom': 'Egen lista',
  'pa.sections': 'Parallellklasser',
  'pa.removeSection': (s: string) => `Ta bort parallellklass ${s}`,
  'pa.inUse': '(används — den inaktiveras, raderas inte)',
  'pa.addSection': 'Lägg till parallellklass',
  'pa.sectionsInUseHint': 'En parallellklass som används inaktiveras, den raderas inte.',
  'pa.addClasses': 'Lägg till klasser',
  'pa.addClassesHint': 'Kryssa för klasserna som ska skapas. Befintliga klasser är ikryssade och låsta.',
  'pa.needLists': 'Ange först årskurser och parallellklasser.',
  'pa.gridCaption': 'Årskurser och parallellklasser; kryssa för en ruta för att skapa klassen',
  'pa.classExistsLabel': (c: string) => `${c} finns redan`,
  'pa.createClassLabel': (c: string) => `Skapa ${c}`,
  'pa.expectedSize': 'Elevantal',
  'pa.expectedSizeHint': 'Obligatoriskt. Antal elever — aldrig namn. Deltagandet räknas utifrån det.',
  'pa.smallClassWarn': 'Under 5: klassens resultat döljs oftast och räknas in i skolans total.',
  'pa.createNClasses': (c: number) => `Skapa ${c} ${n(c, 'klass', 'klasser')}`,
  'pa.classesCreated': (c: number) => `${c} ${n(c, 'klass', 'klasser')} skapade.`,
  'pa.classesThisYear': (y: string) => `Klasser ${y}`,
  'pa.noClassesSchool': 'Inga klasser ännu.',
  'pa.noGrade': 'Ingen årskurs (äldre klasser)',
  'pa.noClassesInGrade': 'Inga klasser i årskursen ännu.',
  'pa.leadChip': (who: string) => `Ansvarig: ${who}`,
  'pa.addGradeLead': '+ Årskursansvarig',
  'pa.addGradeLeadTo': (g: string) => `Lägg till årskursansvarig: ${g}`,
  'pa.removeAssignment': (who: string, c: string) => `Koppla bort ${who} från ${c}`,
  'pa.sizeN': (c: number) => `${c} elever`,
  'pa.sizeUnknown': 'Antal saknas',
  'pa.noTeacher': 'Ingen lärare',
  'pa.assignShort': 'Koppla',
  'pa.assignTo': (c: string) => `Koppla en lärare till ${c}`,
  'pa.size': 'Storlek',
  'pa.editSizeOf': (c: string) => `Elevantal i ${c}`,
  'pa.archive': 'Arkivera',
  'pa.archiveOf': (c: string) => `Arkivera eller radera ${c}`,
  'pa.archiveTitle': (c: string) => `Arkivera ${c}?`,
  'pa.archiveClassIntro': 'Klassen försvinner ur lärarnas val och uppdragen avslutas; historiken behålls. Du kan återställa den.',
  'pa.delete': 'Radera',
  'pa.deleteTitle': (c: string) => `Radera ${c}?`,
  'pa.deleteIntro': 'Klassen har aldrig haft en enkät, så den kan raderas helt.',
  'pa.archivedDone': 'Klassen arkiverad.',
  'pa.deletedDone': 'Klassen raderad.',
  'pa.archivedN': (c: number) => `Arkiverade klasser (${c})`,
  'pa.restore': 'Återställ',
  'pa.restoreOf': (c: string) => `Återställ ${c}`,
  'pa.restored': 'Klassen återställd.',
  'pa.noTeachersYet': 'Ingen har ännu rollen Lärare. Lägg först till en person med den rollen.',
  'pa.searchStaff': 'Sök personal',
  'pa.teacher': 'Lärare',
  'pa.secondHomeroomWarn': 'Klassen har redan en klasslärare. En andra är tillåten (delad tjänst).',

  'pa.profile': 'Skolans uppgifter',
  'pa.codeNeverChanges': 'ändras aldrig',
  'pa.levelsOnClasses': 'Årskurser och parallellklasser finns på fliken Klasser.',
  'pa.safetyNetHint': 'Visas för eleverna i varje enkätvy, på deras språk. Berätta vem de kan prata med och var, samt en stödtelefon.',
  'pa.messageIn': (l: string) => `Meddelande på ${l}`,
  'pa.useTemplate': 'Använd mallen',
  'pa.safetyTemplate_fi': 'Jos sinulla on huolia, voit puhua kuraattorin kanssa: [nimi], huone [numero]. Voit soittaa myös Sekasin-chattiin tai numeroon 116 111 (Lasten ja nuorten puhelin).',
  'pa.safetyTemplate_sv': 'Om något oroar dig kan du prata med kuratorn: [namn], rum [nummer]. Du kan också ringa 116 111 (Barnens och ungas telefon).',
  'pa.safetyTemplate_en': 'If something is worrying you, you can talk to the school counsellor: [name], room [number]. You can also call 116 111 (helpline for children and young people).',
  'pa.previewIn': 'Förhandsvisning på',
  'pa.previewLabel': 'Förhandsvisning av elevvyn',
  'pa.previewEmpty': 'Inget meddelande ännu.',
  'pa.policies': 'Regler',
  'pa.polSelfService': 'Lärare får koppla sig själva till klasser',
  'pa.polSelfServiceDesc': 'Bland skolans befintliga klasser; skoladministratören meddelas och kan ångra. Standard: av.',
  'pa.polWholeSchool': 'Kuratorer ser hela skolan',
  'pa.polWholeSchoolDesc': 'Av: kuratorer ser bara de årskurser de har tilldelats. Standard: på.',
  'pa.confirmations': 'Bekräftelser för ibruktagning',
  'pa.confirmationsHint': 'Steg som sker utanför Swipe. Vart och ett loggas med vem och när.',

  'pa.approvalsIntro': 'Begäranden som bara Zencera avgör: roller som utökar åtkomsten i en skola utan huvudrektor och utan ersättare; och — avgjorda av en andra plattformsadministratör — radering av en huvudrektor eller skoladministratör samt utnämning av huvudrektor på skolans begäran.',
  'pa.waiting': 'Väntar',
  'pa.noApprovals': 'Inga begäranden väntar.',
  'pa.apWiden': (who: string, r: string) => `${who} — lägg till ${r}`,
  'pa.apErase': (who: string) => `${who} — radera personuppgifter`,
  'pa.apWidenWhy': 'Skolan saknar aktiv primär rektor. Bekräfta med skolans undertecknare utanför appen innan du godkänner.',
  'pa.apInstruction': (s: string) => `Skolans instruktion: ${s}`,
  'pa.apWaitingSecond': 'Du begärde detta. Det väntar på en annan plattformsadministratör.',
  'pa.requestedBy': (who: string, d: string) => `begärt av ${who}, ${d}`,
  'pa.expiresOn': (d: string) => `går ut ${d}`,
  'pa.approve': 'Godkänn',
  'pa.approveErase': 'Godkänn och radera',
  'pa.reject': 'Avslå',
  'pa.approveTitle': 'Godkänna begäran?',
  'pa.rejectTitle': 'Avslå begäran?',
  'pa.approved': 'Godkänt.',
  'pa.rejected': 'Avslaget.',

  'pa.logIntro': 'Kan bara utökas och avslöjar ändringar: varje rad bär en hash av raden före. Visar vem som gjorde vad och när — aldrig vad någon såg i resultaten.',
  'pa.logScope': 'Vilken logg',
  'pa.logPlatform': 'Plattformshändelser',
  'pa.logAll': 'Alla skolor och plattformen',
  'pa.logSchool': (s: string) => `Aktivitet — ${s}`,
  'pa.filterAction': 'Filtrera efter åtgärd',
  'pa.allActions': 'Alla åtgärder',
  'pa.from': 'Från',
  'pa.to': 'Till',
  'pa.exportCsv': 'Exportera CSV',
  'pa.verifyChain': 'Kontrollera hashkedjan',
  'pa.chainOk': (c: number) => `Kedjan hel (${c} rader kontrollerade)`,
  'pa.chainBroken': (id: number) => `Kedjan bruten vid rad ${id}`,
  'pa.logEmpty': 'Inget loggat för de här filtren.',
  'pa.logMoreLoaded': (c: number) => `${c} rader till laddade.`,
  'pa.colTime': 'Tid',
  'pa.colWho': 'Vem',
  'pa.colRole': 'I rollen',
  'pa.colAction': 'Åtgärd',
  'pa.colTarget': 'Mål',
  'pa.colDetails': 'Detaljer',
  'pa.archiveIntro': 'Fullständiga kopior av handlingar som är kritiska för verksamheten och regelefterlevnaden. Gallras aldrig, redigeras aldrig.',
  'pa.records': 'Handlingar',
  'pa.filterKind': 'Filtrera efter typ',
  'pa.filterSchool': 'Filtrera efter skola',
  'pa.allKinds': 'Alla typer',
  'pa.noRecords': 'Inga handlingar för de här filtren.',
  'pa.ak_school_created': 'Skola skapad',
  'pa.ak_school_type_changed': 'Skolans typ ändrad',
  'pa.ak_school_state_changed': 'Skolans läge ändrat',
  'pa.ak_paperwork_changed': 'Avtal ändrat',
  'pa.ak_access_widened': 'Åtkomst utökad',
  'pa.ak_primary_head_changed': 'Primär rektor bytt',
  'pa.ak_erasure_receipt': 'Raderingskvitto',
  'pa.ak_suspension_notice': 'Meddelande om avstängning',
  'pa.ak_offboarding_acknowledged': 'Avveckling bekräftad',
  'pa.ak_offboarding_report': 'GDPR-sammanfattning',

  'pa.notifEmail': 'Plattformens aviseringsadress',
  'pa.notifEmailOn': 'Händelser som kräver Zencera skickas hit och visas i aviseringscentret.',
  'pa.notifEmailOff': 'Ingen e-posttjänst finns ännu, så händelserna visas bara i aviseringscentret. Adressen som sparas nu används när e-posten är i bruk.',
  'pa.mfaEnforce': 'Tvåstegsverifiering för plattformsadministratörer',
  'pa.mfaOnBody': 'Varje åtgärd av en plattformsadministratör kräver en inloggning med autentiseringskod.',
  'pa.mfaOffBody': 'Krävs inte ännu. Innan du slår på det:',
  'pa.mfaReqTwo': (c: number) => `Minst två plattformsadministratörer (nu ${c})`,
  'pa.mfaReqAll': 'Varje plattformsadministratör har en autentiseringsapp',
  'pa.mfaReqSession': 'Den här inloggningen använde din autentiseringskod.',
  'pa.mfaVerifyNow': 'Verifiera nu',
  'pa.mfaTurnOn': 'Slå på kravet',
  'pa.mfaTurnOff': 'Slå av kravet',
  'pa.platformAdmins': 'Plattformsadministratörer',
  'pa.platformAdminsHint': 'Zenceras anställda med rollen plattformsadministratör. Nya läggs till separat (README §6). Var och en bör ha två autentiseringsappar: en huvudapp och en reserv.',
  'pa.health': 'Databasens utrymme',
  'pa.dbSize': 'Databasens storlek',
  'pa.freeSpace': 'Ledigt utrymme',
  'pa.actionNeeded': 'Åtgärd behövs',
  'pa.logSize': 'Loggens storlek',
  'pa.archiveRows': 'Handlingar i arkivet',
  'pa.healthHint': 'Bara storlekar — inga skol- eller användaruppgifter. Veckokontrollen varnar när mindre än 0,2 GB är ledigt.',
  'pa.maintenance': 'Underhåll',
  'pa.sweepHint': 'Utgångna testkonton raderas automatiskt varje natt. Du kan köra raderingen nu.',
  'pa.sweepNow': 'Radera utgångna testkonton nu',
  'pa.sweepIntro': 'Raderar varje testkonto som har gått ut, med ett kvitto för vart och ett. Detta kan inte ångras.',
  'pa.sweepGo': 'Radera dem',
  'pa.sweepDone': (c: number) => `${c} ${n(c, 'utgånget testkonto raderat', 'utgångna testkonton raderade')}.`,
  'pa.rosterHint': 'Lägg till personer på skolans flik Personal: testkonton i sandlådeskolor, inbjudningar i kundskolor.',

  'lvl.vl1': '1', 'lvl.vl2': '2', 'lvl.vl3': '3', 'lvl.vl4': '4', 'lvl.vl5': '5', 'lvl.vl6': '6',
  'lvl.vl7': '7', 'lvl.vl8': '8', 'lvl.vl9': '9',
  'lvl.lukio1': 'Gymnasium 1', 'lvl.lukio2': 'Gymnasium 2', 'lvl.lukio3': 'Gymnasium 3',
  'lvl.amm': 'Yrkesutbildning',

  'notif.title': 'Aviseringar',
  'notif.bell': 'Aviseringar',
  'notif.bellUnread': (c: number) => `Aviseringar, ${c} olästa`,
  'notif.home': 'Startsida',
  'notif.unreadN': (c: number) => `${c} olästa`,
  'notif.allCaughtUp': 'Allt läst',
  'notif.markAll': 'Markera alla som lästa',
  'notif.allRead': 'Alla markerade som lästa.',
  'notif.empty': 'Inget här ännu. Ändringar som berör dig visas här.',
  'notif.new': 'Ny',
  'notif.roleAdded': (r: string) => `Du har fått rollen ${r}.`,
  'notif.roleRemoved': (r: string) => `Din roll ${r} togs bort.`,
  'notif.approvalWaiting': (r: string) => `En begäran om att lägga till ${r} väntar på ditt godkännande.`,
  'notif.approvalNoHead': (r: string) => `En skola utan primär rektor behöver Zenceras beslut om att lägga till ${r}.`,
  'notif.approvalApproved': 'Din begäran godkändes.',
  'notif.approvalRejected': 'Din begäran avslogs.',
  'notif.eraseSecond': 'En radering behöver en annan plattformsadministratörs godkännande.',
  'notif.assigned': (c: number) => `Du har kopplats till ${c} ${n(c, 'klass', 'klasser')}.`,
  'notif.unassigned': 'Du kopplades bort från en klass.',
  'notif.primaryHead': 'Du är nu primär rektor.',
  'notif.paperwork': (s: string) => `Avtalets status ändrades: ${s}.`,
  'notif.schoolLive': 'Ibruktagningen är klar: enkäterna kan öppnas.',
  'notif.dedicatedRequested': 'Nivå B: sätt upp en egen databas för skolan och bekräfta den på skolans sida.',
  'notif.dedicatedCancelled': 'Nivå B avbruten: skolan behöver inte längre en egen databas.',
  'notif.dedicatedPending': 'Zencera sätter upp din skolas egna databas. Du meddelas när den är klar.',
  'notif.dedicatedReady': 'Din skolas egna databas är klar.',
  'notif.reactivated': 'En anställd återaktiverades automatiskt.',

  'pa.soTitle': 'Inne i skolan — bara i supportläge',
  'pa.soBody': (what: string) => `${what} hör till skolan. Zencera ser och ändrar dem bara i supportläge: med en orsak, i två timmar, loggat i skolans egen aktivitetslogg och i plattformsloggen.`,
  'pa.soHint': 'Skolans sammanfattning, checklista, livscykel och aktivitet finns kvar utan det.',
  'pa.soStaff': 'Personalens namn, e-post, roller och inloggningar',
  'pa.soClasses': 'Klasser och lärarnas uppdrag',
  'pa.soSettings': 'Skolans uppgifter, regler och stödmeddelande',
  'pa.soPerson': 'Personens uppgifter, roller och konto',
  'pa.soOffboardedTitle': 'Skolan har lämnat Swipe',
  'pa.soOffboardedBody': 'Personalens uppgifter raderades vid avvecklingen. GDPR-sammanfattningen finns i arkivet.',
  'pa.apNeedsSupport': 'Beslutet öppnar först skolans supportläge (loggas i dess aktivitet).',
  'head.approvals': (c: number) => `Väntande godkännanden (${c})`,
  'head.approvalsHint': 'Roller som utökar vad någon ser väntar på dig som primär rektor. Begärandena går ut efter 14 dagar.',
  'teacher.notReady': 'Skolans ibruktagning är inte klar, så enkäter kan inte öppnas ännu. Fråga skolans administratör.',
  'teacher.startFailed': 'Enkäten kunde inte öppnas. Försök igen.',

  'err.password_not_changed': 'Ditt nya lösenord har inte sparats ännu. Välj ett nytt lösenord och försök igen.',
  'err.password_change_required': 'Välj först ett eget lösenord.',
  'pa.pendingRolesNote': (roles: string) =>
    `Väntar på godkännande av den primära rektorn: ${roles}. Kontot kan använda rollerna när de har godkänts.`,
  'pw.title': 'Välj ett eget lösenord',
  'pw.intro': (name: string) =>
    `Välkommen, ${name}. Lösenordet du fick fungerar bara för en inloggning. Välj ett nytt som bara du känner till — inget öppnas innan dess.`,
  'pw.new': 'Nytt lösenord',
  'pw.again': 'Nytt lösenord igen',
  'pw.hint': (min: number) => `Minst ${min} tecken. Några orelaterade ord blir ett bra lösenord.`,
  'pw.tooShort': (min: number) => `Använd minst ${min} tecken.`,
  'pw.mismatch': 'Lösenorden är olika. Skriv samma lösenord i båda fälten.',
  'pw.sameAsBefore': 'Det är lösenordet du fick. Välj ett annat.',
  'pw.weak': 'Lösenordet är för lätt att gissa. Välj ett längre eller ovanligare.',
  'pw.save': 'Spara lösenordet',
  'pw.saving': 'Sparar…',
  'pw.retry': 'Försök igen',
  'pw.failed': 'Lösenordet kunde inte sparas. Kontrollera anslutningen och försök igen.',
  'pw.savedRetry': 'Ditt nya lösenord är sparat, men Swipe kunde inte bekräfta det ännu. Försök igen — du behöver inte skriva det igen.',
};
